import { render } from "./SelectColor.vue?vue&type=template&id=59a29a22&scoped=true"
import script from "./SelectColor.vue?vue&type=script&lang=js"
export * from "./SelectColor.vue?vue&type=script&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=59a29a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a29a22"]])

export default __exports__